<div class="main-div">
  <h1 class="main-header-text">Vozovi</h1>
  <!---Table--->
  <div class="flex table-top-area">
    <div>
      <app-search></app-search>
    </div>
    <div class="add-station-div">
      <button mat-icon-button disableRipple (click)="openDialog()">
        <mat-icon svgIcon="add" class="add" matTooltip="Kreiraj voz"></mat-icon>
      </button>
    </div>
  </div>
  <!---Table--->
  <table class="table-style" mat-table [dataSource]="data" matSort>
    <ng-container matColumnDef="ID TRAIN">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="id" id="train_id">ID</th>
      <td mat-cell *matCellDef="let element">
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="OPERATOR_NAME">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="operator.name" id="operator">Operator</th>
      <td mat-cell *matCellDef="let element">{{ element.operator.name }}</td>
    </ng-container>

    <ng-container matColumnDef="CATEGORY_NAME">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="trainCategory.name" id="category">Kategorija</th>
      <td mat-cell *matCellDef="let element">
        {{ element.trainCategory.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="TRAIN_NAME">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name" id="train_name">Naziv</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="AKCIJA">
      <th mat-header-cell *matHeaderCellDef class="p-0">Akcije</th>
      <td mat-cell *matCellDef="let element" class="cell-size-actions">
        <div class="cell-actions">
          <button mat-icon-button (click)="getById(element.id)">
            <mat-icon svgIcon="edit" class="edit" matTooltip="Ažuriraj"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteDialog(element)">
            <mat-icon svgIcon="delete" class="delete" matTooltip="Obriši"></mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div class="paginator">
    <mat-paginator [length]="total" [pageSize]="10" [hidePageSize]="true" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>
</div>
